//React
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
//API
import { WoundApi } from '../../apis/index';
//Material-UI
import Grid from '@material-ui/core/Grid';
//Components
import MyLoading from '../../components/Loading.js';

const WoundMetaSave = (props) => {
  const [woundInfo, setWoundInfo] = useState({
    woundName: '',
    ink2Ratio: 0,
    woundType: 0,
    stlThreshold: 0.94,
  });
  const [loading, setLoading] = useState(false);

  const changeValue = (e) => {
    setWoundInfo({
      ...woundInfo,
      [e.target.name]: e.target.value,
    });
  };

  const submitWound = async (e) => {
    e.preventDefault(); // 기존 submit 을 실행하지않게

    const res = await WoundApi.dupleWoundName(woundInfo.woundName);
    if (res.data) {
      alert('이미 존재하는 Wound Name 입니다.');
      return;
    } else {
      const formData = new FormData();
      formData.append('woundName', woundInfo.woundName);
      formData.append('ink2Ratio', woundInfo.ink2Ratio);
      formData.append('woundType', woundInfo.woundType);
      formData.append('stlThreshold', woundInfo.stlThreshold);
      setLoading(true);
      const res = await WoundApi.saveWound(formData);
      if (res.statusCode === 200) {
        alert('새로운 Wound를 등록하였으면, 관리자에게 notice 해주세요.');
        props.history.push('/woundMetaList');
      } else {
        setLoading(false);
        alert('Wound 정보 저장에 실패하였습니다.');
      }
    }
  };

  return (
    <Form onSubmit={submitWound} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
      <Form.Group>
        <Form.Label>Wound Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="WoundName"
          onChange={changeValue}
          name="woundName"
          value={woundInfo.woundName}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>ink2Ratio</Form.Label>
        <Form.Control
          type="number"
          placeholder="ink2Ratio"
          onChange={changeValue}
          name="ink2Ratio"
          value={woundInfo.wounink2RatiodName}
          onWheel={(e) => e.target.blur()}
          min={0}
          max={50}
          required
        />
        <span style={{ fontSize: '.8rem', color: '#555' }}>
          - SKIN : 20 (Default)
          <br />- CARTILAGE : 40
        </span>
      </Form.Group>

      <Form.Group>
        <Form.Label>Wound Type</Form.Label>
        <Form.Control
          type="number"
          placeholder="woundType"
          onChange={changeValue}
          name="woundType"
          value={woundInfo.woundType}
          onWheel={(e) => e.target.blur()}
          min={0}
          max={100}
          required
        />
        <span style={{ fontSize: '.8rem', color: '#555' }}>
          - SKIN : 0 ~ 49
          <br />
          - CARTILAGE : 50 ~ 98
          <br />- OTHER : 99
        </span>
      </Form.Group>

      <Form.Group>
        <Form.Label>STL Threshold</Form.Label>
        <Form.Control
          type="number"
          placeholder="stlThreshold"
          onChange={changeValue}
          name="stlThreshold"
          value={woundInfo.stlThreshold}
          onWheel={(e) => e.target.blur()}
          defaultValue={0.94}
          required
        />
      </Form.Group>

      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <button
          className="red"
          style={{ marginRight: '25px' }}
          onClick={() => {
            props.history.goBack();
          }}
        >
          Back
        </button>
        <button className="blue" style={{ marginLeft: '25px' }} type="submit">
          Save
        </button>
      </Grid>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </Form>
  );
};

export default WoundMetaSave;
